import http from '@/services/Http/http'
import axios from 'axios'
import { BusinessException, TechnicalException } from '@/services/ErrorHandler'

export default {
  async requestDocumentUpload (fileName, mimeTypeCode) {
    let params = {
      version: '3.0'
    }
    try {
      let requestBody = {
        fileName: fileName,
        mimeTypeCode: mimeTypeCode
      }
      let response = await http.Document.post('documents', requestBody, { params })
      return response.data
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async uploadDocument (uri, file) {
    try {
      let config = {
        baseURL: undefined,
        headers: {
          'x-ms-blob-type': 'BlockBlob',
          'x-ms-version': '2021-12-02'
        }
      }
      let axiosInstance = axios.create(config)
      let response = await axiosInstance.put(uri, file)
      return (response.status === 201 || response.status === 200) // handle success code different between azure and aws
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async getDocument (dui) {
    let params = {
      version: '3.0'
    }
    try {
      let response = await http.Document.get(`documents/${dui}`, { params })
      return response.data
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  }
}
